<div class="container" [ngClass]="{ 'show-padding': focus !== 'thread' }">
  <div class="inner-container theme-background-color large-element-rounding">
    <app-task-detail
      [orgId]="orgId"
      [taskId]="taskId"
      [focus]="focus"
    ></app-task-detail>
  </div>
</div>
